import * as React from "react";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import type { LtlFormCapabilities } from "@src/types/api";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";
import type { BolDetailsFormValues } from "./bolDetailsFormTypes";

type BlockProps = {
  form: BolDetailsFormValues;
  errors: Record<string, string>;
  caps: LtlFormCapabilities;
  onFieldBlur?: () => void;
  handleInputChange: (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => void;
  getTextFieldStyles: (fieldName: keyof BolDetailsFormValues) => Partial<ITextFieldStyles>;
};

export function BolDetailsAddressPartyBlock({
  form,
  errors,
  caps,
  onFieldBlur,
  handleInputChange,
  getTextFieldStyles,
}: BlockProps): React.ReactElement {
  return (
    <>
      <TextField
        label="Shipper Name"
        name="shipperName"
        value={form.shipperName ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        required={!!caps.requiresShipperName}
        id={ltlFieldInputId("shipperName")}
        styles={getTextFieldStyles("shipperName")}
        errorMessage={errors.shipperName}
      />
      <TextField
        label="Consignee Name"
        name="consigneeName"
        value={form.consigneeName ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("consigneeName")}
        styles={getTextFieldStyles("consigneeName")}
        errorMessage={errors.consigneeName}
      />
      <TextField
        label="Company Name"
        name="companyName"
        value={form.companyName ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("companyName")}
        styles={getTextFieldStyles("companyName")}
        errorMessage={errors.companyName}
      />
    </>
  );
}
